const Home_Map_Data = [
  {
    id: 1,
    top: "73%",
    left: "35%",
    imageUrl: "./images/Map/locationpin.png",
    hoverText: "Andhra Pradesh",
  },
  {
    id: 2,
    top: "63%",
    left: "34%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Telangana",
  },
  {
    id: 3,
    top: "52.10%",
    left: "44%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Chattisgarh",
  },
  {
    id: 4,
    top: "25.70%",
    left: "30.70%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Delhi",
  },
  {
    id: 5,
    top: "33.70%",
    left: "42.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Uttar Pradesh",
  },
  {
    id: 6,
    top: "45.60%",
    left: "31.20%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Madhya Pradesh",
  },
  {
    id: 7,
    top: "57.60%",
    left: "23.20%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Maharashtra",
  },
  {
    id: 8,
    top: "46.00%",
    left: "10.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Gujarat",
  },
  {
    id: 9,
    top: "86.30%",
    left: "33.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Tamil Nadu",
  },
  {
    id: 10,
    top: "45.70%",
    left: "63.20%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "West Bengal",
  },
  {
    id: 11,
    top: "34.40%",
    left: "17.80%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Rajasthan",
  },
  {
    id: 12,
    top: "25.40%",
    left: "25.80%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Haryana",
  },
  {
    id: 13,
    top: "37.70%",
    left: "56.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Bihar",
  },
  {
    id: 14,
    top: "72.70%",
    left: "23.10%",
    imageUrl: "./images/Map/locationpin.png",
    hoverText: "Karnataka",
  },
  {
    id: 15,
    top: "85.70%",
    left: "25.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Kerala",
  },
  {
    id: 16,
    top: "52.70%",
    left: "54.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Odisha",
  },
  {
    id: 17,
    top: "29.7%",
    left: "66.9%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Sikkim",
  },
  {
    id: 18,
    top: "71.10%",
    left: "17.50%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Goa",
  },
  {
    id: 19,
    top: "5.70%",
    left: "21.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Jammu & Kashmir",
  },
  {
    id: 20,
    top: "17.50%",
    left: "22.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Punjab",
  },
  {
    id: 21,
    top: "43.70%",
    left: "55.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Jharkhand",
  },
  {
    id: 22,
    top: "14.70%",
    left: "29.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Himachal Pradesh",
  },
  {
    id: 23,
    top: "21.70%",
    left: "36.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Uttarakhand",
  },
  {
    id: 24,
    top: "34.50%",
    left: "82.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Assam",
  },
  {
    id: 25,
    top: "36.70%",
    left: "76.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Meghalaya",
  },
  {
    id: 26,
    top: "34.70%",
    left: "88.10%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Nagaland",
  },
  {
    id: 27,
    top: "44.70%",
    left: "81.3%",
    imageUrl: "./images/Map/locationpin.png",

    hoverText: "Mizoram",
  },
  {
    id: 28,
    top: "27.70%",
    left: "85.10%",
    imageUrl: "./images/Map/locationpin.png",
    hoverText: "Arunachal Pradesh",
  },
  {
    id: 29,
    top: "43.20%",
    left: "78.10%",
    imageUrl: "./images/Map/locationpin.png",
    hoverText: "Tripura",
  },
  {
    id: 30,
    top: "39.70%",
    left: "85.10%",
    imageUrl: "./images/Map/locationpin.png",
    hoverText: "Manipur",
  },
  {
    id: 31,
    top: "4.70%",
    left: "29.10%",
    imageUrl: "./images/Map/locationpin.png",
    hoverText: "Ladakh",
  },
];
const Home_IndustriesWeServe_Data = [
  {
    id: 1,
    image: "./images/Networks/Construction.png",
    title: "Construction",
  },
  // {
  //   id: 2,
  //   image: "./images/Networks/Engineering.png",
  //   title: "Engineering",
  // },
  {
    id: 3,
    image: "./images/Networks/Highways.png",
    title: "Roadways and Highways",
  },
  {
    id: 4,
    image: "./images/Networks/Bridges.png",
    title: "Dams and Bridges",
  },
  {
    id: 5,
    image: "./images/Networks/Fabrication.png",
    title: "Fabrication Works",
  },
  {
    id: 6,
    image: "./images/Networks/Plants.png",
    title: "Power Plants",
  },
  {
    id: 7,
    image: "./images/Networks/Cement.png",
    title: "Cement",
  },
  {
    id: 8,
    image: "./images/Networks/Infrastructure.png",
    title: "Infrastructure",
  },
  {
    id: 9,
    image: "./images/Networks/Estate.png",
    title: "Real Estate",
  },
];
const Home_WhyChooseUs_Data = [
  {
    image: "./images/WhyChooseUs/New/1.png",
    title: "Reliable Products",
  },
  {
    image: "./images/WhyChooseUs/New/2.png",
    title: "Customization Available",
  },
  {
    image: "./images/WhyChooseUs/New/3.png",
    title: "Durable Lifespan",
  },
  {
    image: "./images/WhyChooseUs/New/4.png",
    title: "Always On-Time Delivery",
  },
  {
    image: "./images/WhyChooseUs/New/5.png",
    title: "Provide Logistics Support",
  },
];
const Certificates_Data = [
  {
    id: 1,
    img: "c-1.png",
  },
  {
    id: 2,
    img: "c-2.png",
  },
  {
    id: 3,
    img: "c-3.png",
  },
  {
    id: 4,
    img: "c-4.png",
  },
  {
    id: 5,
    img: "c-5.png",
  },
  {
    id: 6,
    img: "c-6.png",
  },
];
const Brands_Data = [
  //12
  {
    id: 1,
    img: "b-1.png",
  },
  {
    id: 2,
    img: "b-2.png",
  },
  {
    id: 3,
    img: "b-3.png",
  },
  {
    id: 4,
    img: "b-4.png",
  },
  {
    id: 5,
    img: "b-5.png",
  },
  {
    id: 6,
    img: "b-6.png",
  },
  {
    id: 7,
    img: "b-7.png",
  },
  {
    id: 8,
    img: "b-8.png",
  },
  {
    id: 9,
    img: "b-9.png",
  },
  {
    id: 10,
    img: "b-10.png",
  },
  {
    id: 11,
    img: "b-11.png",
  },
  {
    id: 12,
    img: "b-12.png",
  },
];
const WireProducts_Data = [
  {
    id: 1,
    imageUrl: "",
    title: "MS Gi Binding Wire",
    diameter: "0.90 mm to 6.00 mm",
    zincCoating: "30 to 366 GSM",
    tensileStrength: "300 to 900 ^2",
    standard:
      "IS 280(1978), BS 443 (1982), BS 5467 (1997), BS 6622 (2007), BS 7846, ASTM A641/A641m (1998) Class A, IS G3547 (1993), AS 1650 (1989), AS 2423",
  },
  {
    id: 2,
    imageUrl: "",
    title: "PVC Coated Gi Binding Wire",
    diameter: "0.90 mm to 2.00 mm",
    zincCoating: "30 to 366 GSM",
    tensileStrength: "300 to 900 ^2",
    standard:
      "IS 280(1978), BS 443 (1982), BS 5467 (1997), BS 6622 (2007), BS 7846, ASTM A641/A641m (1998) Class A, IS G3547 (1993), AS 1650 (1989), AS 2423",
  },
  {
    id: 3,
    imageUrl: "",
    title: "Gi Barbed Wire",
    material: "Low Carbon Steel",
    diameter: "2.00 mm to 4.00 mm",
    zincCoating: "300 GSM to 600 GSM",
    tensileStrength: "350 ^2 to 500 ^2",
    barbHeight: "10 mm to 16 mm",
    rollLength: " 50 m to 100 m",
  },
  {
    id: 4,
    imageUrl: "",
    title: "Weld Mesh",
    diameter: "1.00 mm to 8.00 mm",
    sectionOfTheRoll: " 25 mm to 250 mm",
    widthOfTheRoll: "900 mm (3 feet) to 2700 mm (9 feet)",
    rawMaterialGrade:
      "Mild Steel Wire, Galvanized Wire, SS Wire, High Carbon Wire",
    standard: "IS 1566, IS 432 (part II)/1982/2002, BS:4482/1969, BS:4483/1969",
  },
  {
    id: 5,
    imageUrl: "",
    title: "PVC Gi Chain Link Mesh",
    hotDippedGalvanizedWire: "IS 280",
    wireSize: "1.6 mm to 4 mm (8 to 16 gauge)",
    widthHeight: "3 Feet to 10 Feet",
    Length: "15mtr to 30mtr",
    zincCoating: "60gsm to 300gsm",
    meshSize: "1” to 4” 25mm to 100mm",
  },
  {
    id: 6,
    imageUrl: "",
    title: "MS Wire Nails",
    material: "Mild Steel",
    diameter: "1.6 mm to 5.0 mm",
    length: "15 mm to 100 mm",
    headType: "Round head/flat head",
    pointType: "diamond point/chisel point",
    zincCoatingWeight: "300 GSM to 600 GSM ",
    standards: "IS 280, IS 2629, IS 4268, ASTM A153",
  },
];

const Products_Data = [
  // Wire Products
  {
    product_id: "WPA7",
    product_category: "wire_products",
    product_name: "galvanized_binding_wire",
    product_rows: "Diameter,zinc coating,Tensile strength,Standards",
    value1: "0.70 mm(22G) to 6.00mm(3G)",
    value2: "20 to 275 GSM",
    value3: "300 to 900 ^2",
    value4:
      " IS 280(1978), BS 443 (1982), BS 5467 (1997), BS 6622 (2007), BS 7846, ASTM A641/A641m (1998) Class A, IS G3547 (1993), AS 1650 (1989), AS 2423",
  },
  {
    product_id: "WPF3",
    product_category: "wire_products",
    product_name: "mild_steel_binding_wire",
    product_rows: "Diameter,Tensile strength,Standards",
    value1: "0.90 mm to 6.00 mm",
    value2: "300 to 900 ^2",
    value3:
      "Standards - IS 280(1978), BS 443 (1982), BS 5467 (1997), BS 6622 (2007), BS 7846, ASTM A641/A641m (1998) Class A, IS G3547 (1993), AS 1650 (1989), AS 2423",
  },
  {
    product_id: "WPX1",
    product_category: "wire_products",
    product_name: "pvc_coated_binding_wire",
    product_rows: "Diameter,zinc coating,Tensile strength,Standards",
    value1: "1.22 mm to 2.00 mm",
    value2: "30 to 275 GSM",
    value3: "300 to 900 ^2",
    value4:
      "- IS 280(1978), BS 443 (1982), BS 5467 (1997), BS 6622 (2007), BS 7846, ASTM A641/A641m (1998) Class A, IS G3547 (1993), AS 1650 (1989), AS 2423",
  },
  {
    product_id: "WPG8",
    product_category: "wire_products",
    product_name: "galvanized_weld_mesh",
    product_rows:
      "Wire Diameter ,Section of the roll ,Width of the roll ,Standards ",
    value1: "1.00 mm to 6.00 mm",
    value2: "25 mm to 250 mm",
    value3: "900 mm (3 feet) to 2700 mm (9 feet)",
    value4: "IS 1566, IS 432 (part II)/1982/2002, BS:4482/1969, BS:4483/1969",
  },
  {
    product_id: "WPM6",
    product_category: "wire_products",
    product_name: "mild_steel_weld_mesh",
    product_rows:
      "Wire Diameter ,Section of the roll ,Width of the roll ,Standards ",
    value1: "1.00 mm to 6.00 mm",
    value2: "25 mm to 250 mm",
    value3: "900 mm (3 feet) to 2700 mm (9 feet)",
    value4: "IS 1566, IS 432 (part II)/1982/2002, BS:4482/1969, BS:4483/1969",
  },
  {
    product_id: "WPR2",
    product_category: "wire_products",
    product_name: "galvanized_chain_link_mesh",
    product_rows: "Wire Size,Width/height,Length,Zinc coating,Mesh size",
    value1: "1.6 mm to 4 mm (8 to 16 gauge)",
    value2: "3 Feet to 10 Feet",
    value3: "5mtr-30mtr",
    value4: "30GSM to 300GSM",
    value5: "1 inch to 4 inch 25mm to 100mm",
  },
  {
    product_id: "WPB5",
    product_category: "wire_products",
    product_name: "mild_steel_wire_nails",
    product_rows:
      "Material,Diameter,Length,Head Type,Point Type,Zinc Coating Weight",
    value1: "Mild Steel",
    value2: "1.6 mm to 5.0 mm",
    value3: "15 mm to 100 mm",
    value4: " Round head/flat head",
    value5: "diamond point/chisel point",
    value6: " 300 GSM to 600 GSM",
  },
  {
    product_id: "WPQ9",
    product_category: "wire_products",
    product_name: "pvc_coated_link_mesh",
    product_rows: "Wire Size,Width/height,Length,Zinc coating,Mesh size",
    value1: "1.6 mm to 4 mm (8 to 16 gauge)",
    value2: "3 Feet to 10 Feet",
    value3: "15mtr to 30mtr",
    value4: "60gsm to 300gsm",
    value5: "1” to 4” 25mm to 100mm",
  },
  {
    product_id: "WPD4",
    product_category: "wire_products",
    product_name: "barbed_wire",
    product_rows:
      "Diameter,Zinc coating weight,Tensile strength,Barb height,Roll Length",
    value1: " 2.00 mm to 4.00 mm",
    value2: " 60 GSM to 300 GSM",
    value3: " 350 ^2 to 500 ^2",
    value4: "50 m to 100 m",
    value5: undefined,
  },

  // Galvanized and Coated Products
  {
    product_id: "GCK3",
    product_category: "galvanized_and_coated_products",
    product_name: "galvanized_corrugated_sheet",
    product_rows: "Coating,Thickness,Width,Length",
    value1: "Typically 80 - 400 GSM",
    value2: "0.20mm to 0.80mm",
    value3: "800mm to 1320mm.",
    value4: "10mtr as per requirement",
  },
  {
    product_id: "GCE1",
    product_category: "galvanized_and_coated_products",
    product_name: "pre-painted_galvanized_profile_sheets",
    sub_products: [
      {
        product_id: "GCE51",
        product_name: "pre-painted_galvanized_profile_sheets",
      },
      { product_id: "GCES5", product_name: "bare_galvalume" },
      { product_id: "GCEA6", product_name: "galvalume" },
    ],
    // product_rows:
    //   "Base Metal Thickness,Paint System,Paint Thickness,Colour Availability,Grades",
    // value1: " 0.25mm to 1.00",
    // value2: " As per requirement",
    // value3: " As per requirement",
    // value4: "All Colors.",
    // value5: "ASTMA A755,EN 10169,IS15965",
  },
  {
    product_id: "GCE51",
    product_name: "pre-painted_galvanized_profile_sheets",
    product_category: "painted_galvanized_profile_sheets",
    product_rows:
      "Base Metal Thickness,Paint System,Paint Thickness,Colour Availability,Grades",
    value1: "0.25mm to 1.00",
    value2L: "As per requirement",
    value3: "As per requirement",
    value4: "All Colors",
    value5: "ASTMA A755,EN 10169,IS15965",
  },
  {
    product_id: "GCES5",
    product_category: "painted_galvanized_profile_sheets",
    product_name: "bare_galvalume",
    product_rows: "Base metal thickness,Grades",
    value1: " 0.25mm to 1.00",
    value2: "ASTMA A755,EN 10169,IS15965",
  },
  {
    product_id: "GCEA6",
    product_category: "painted_galvanized_profile_sheets",
    product_name: "galvalume",
    product_rows:
      "Base Metal Thickness,Paint System,Paint Thickness, Colour,Availability, Grades",
    value1: "0.25mm to 1.00",
    value2: " As per requirement",
    value3: "As per requirement",
    value4: " All Colors.",
    value5: "ASTMA A755,EN 10169,IS15965, AZ70 and AZ150",
    value6: undefined,
  },
  {
    product_id: "GCY7",
    product_category: "galvanized_and_coated_products",
    product_name: "c_purlin",
    sub_products: [
      {
        product_id: "GCY7S",
        product_name: "galvanized_C_purlin",
      },
      {
        product_id: "GCY7V",
        product_name: "mild_steel_C_purlin",
      },
    ],
  },
  {
    product_id: "GCY7S",
    product_category: "c_purlin",
    product_name: "galvanized_C_purlin",
    product_rows:
      "Material,Base metal thickness,Zinc coating weight,Profile dimensions,Length",
    value1: "Cold-Formed Galvanized Steel",
    value2: "0.50 mm to 2.00 mm",
    value3: "120 GSM to 275 GSM",
    value4: " Web Height (mm) * Flange Width (mm)",
    value5: " 3 m to 12 m (As per requirement)",
  },
  {
    product_id: "GCY7V",
    product_category: "c_purlin",
    product_name: "mild_steel_C_purlin",
    product_rows: "Base metal thickness,Profile dimensions,Length",
    value1: "0.50 mm to 2.00 mm",
    value2: " Web Height (mm) * Flange Width (mm)",
    value3: " 3 m to 12 m (As per requirement)",
  },
  {
    product_id: "GCW2",
    product_category: "galvanized_and_coated_products",
    product_name: "Sail_hard_plates",
    product_rows: "Width,Thickness,Length,Grades",
    value1: "1250mm to 3000mm",
    value2: "6mm to 120mm ",
    value3: "5m to 12m",
    value4: "IS 2002 Grade A, B & C",
  },
  {
    product_id: "GCZ4",
    product_category: "galvanized_and_coated_products",
    product_name: "Z_purlin",
    product_rows:
      "Material,Base metal thickness,Zinc coating weight,Profile dimensions,Length",
    value1: "Cold-Formed Galvanized Steel",
    value2: "0.50 mm to 2.00 mm",
    value3: "120 GSM to 275 GSM",
    value4: " Web Height (mm) * Flange Width (mm)",
    value5: " 3 m to 12 m (As per requirement)",
  },
  {
    product_id: "GCH5",
    product_name: "Deck_sheet",
    product_category: "galvanized_and_coated_products",
    product_rows:
      "Material,Base metal thickness,Zinc coating weight,Profile dimensions,Width",
    value1: "Galvanized Steel",
    value2: "0.70 mm to 2.00 mm",
    value3: "80 GSM to 400 GSM",
    value4: "Web Height (mm) * Flange Width (mm)",
    value5: " 3 m to 12 m (As per requirement)",
  },
  {
    product_id: "GCX9",
    product_name: "gi_plain_sheet",
    product_category: "galvanized_and_coated_products",
    product_rows: "Thickness(in mm),width(in mm),length(in mm)",
    value1: "0.25-6",
    value2: "900-1500",
    value3: "500-12000",
  },
  // Pipes Products
  {
    product_id: "PPL4",
    product_category: undefined,
    product_name: "Rectangular_hollow_section",
    product_rows:
      "Size,thickness(in mm).length(in m),surface finishing,material grade",
    value1: " 10x30 to 600x400 mm",
    value2: "1.2 to 6",
    value3: "4.0 to 12",
    value4: "Black or Galvanized as per requirement",
  },
  {
    product_id: "PPQ1",
    product_category: undefined,
    product_name: "Square_hollow_section",
    product_rows:
      "Size,thickness(in mm).length(in m),surface finishing,material grade",
    value1: "15x15 to 180x180 mm",
    value2: "1.00mm to 6",
    value3: "4.0 to 12",
    value4: " Black",
  },
  {
    product_id: "PPC2",
    product_category: "PIPES",
    product_name: "mild_steel_round_pipe",
    product_rows:
      "Size,thickness(in mm).length(in m),surface finishing,material grade",
    value1: "15NB to 200 mm NB",
    value2: "1.2 to 6",
    value3: "4.0 to 12",
    value4: " Black",
  },
  {
    product_id: "PPX8",
    product_category: "PIPES",
    product_name: "galvanized_pipe",
    product_rows: "SIze,thickness,length",
    value1: "15NB to 200 mm NB",
    value2: "1.2 to 6",
    value3: "4.0 to 12",
  },
  {
    product_id: "PPS6",
    product_category: "PIPES",
    product_name: "Seamless_pipes",
    product_rows: "Diameter,length,grades",
    value1: "6-530mm",
    value2: "3-18 or as per  requirement.",
    value3:
      "ASTM A106, ASTM A312, ASTM A53, ASTM A333, ASTM A335, ASTM A511, ASTM A519, ASTM A789, ASTM A790.",
  },
  // Structural Steel - Long Products
  {
    product_id: "SSL7",
    product_category: "structural_steel-long_products",
    product_name: "mild_steel_angle(ISA)",
    product_rows: "equal angles,unequal angles,galvanization",
    value1:
      "Size - Side x Side x Thickness,Size (in mm) - 20x20x3 to 250x250x35",
    value2: "Size (in mm) - 30x20x3 to 200x150x18",
    value3: "As per requirement",
  },
  {
    product_id: "SSB1",
    product_category: "structural_steel-long_products",
    product_name: "mild_steel_beam(ISMB)",
    product_rows: "Size(in mm),length(in mtr),Grades",
    value1: "100x50x5 to 600x210x12",
    value2: "As per Requirement",
    value3: "E250,E275,E300,E350,E410,E450",
  },
  {
    product_id: "SSC9",
    product_category: "structural_steel-long_products",
    product_name: "mild_steel_channel(ISMC)",
    product_rows: "Dimensions(in mm),length,Galvanization",
    value1: "75 x 40 x 7.14 to 400x100x50",
    value2: "10 to 12",
    value3: "As per requirement",
  },
  {
    product_id: "SSR2",
    product_category: "structural_steel-long_products",
    product_name: "mild_steel_round_bar",
    product_rows: "Length(in mm),diameter(in mm)",
    value1: "100 to 6000",
    value2: "5 to 500",
  },
  {
    product_id: "SSF4",
    product_category: "structural_steel-long_products",
    product_name: "mild_steel_flat(ISF)",
    product_rows: "Size,Galvanization",
    value1: "12x3 to 500x25",
    value2: "As per requirement",
  },
  {
    product_id: "SSQ5",
    product_category: "structural_steel-long_products",
    product_name: "mild_steel_square_bar",
    product_rows:
      "Length(in metres),Thickness,Sizes,Grade,Standards,Minimum Tensile Strength,Elongation",
    value1: "6 to 18",
    value2: "Varies, with common ranges including 4-5 mm and 25-45 mm.",
    value3: " 16 mm x 16 mm, 20 mm x 20 mm.",
    value4: " Fe 500 and E250 are common grades",
    value5: "May conform to standards like ASTM A615.",
    value6: " 250 MPa (for E250 grade).",
    value7: " 0.8% (for E250 grade).",
  },
  {
    product_id: "SST3",
    product_category: "structural_steel-long_products",
    product_name: "TMT_bar",
    product_rows: "Diameter,Grades,Yield Strength,UTS ,Elongation % -",
    value1: "6 to 40 mm",
    value2: "Fe500 / Fe500D / Fe550 / Fe550D / Fe600",
    value3: "500 to 600 ^2",
    value4: " 485 to 585 ^2",
    value5: " 8 to 14.5%",
  },
  {
    product_id: "SSU6",
    product_category: "structural_steel-long_products",
    product_name: "crane_rails",
    sub_products: [
      {
        product_id: "SSU6C",
        product_name: "crane_rails",
      },
      {
        product_id: "SSU6A",
        product_name: "Industrial_rails",
      },
      {
        product_id: "SSU6B",
        product_name: "used_and_new_rails",
      },
    ],
  },
  {
    product_id: "SSU6C",
    product_category: "structural_steel-long_products",
    product_name: "crane_rails",
  },
  {
    product_id: "SSU6A",
    product_category: "crane_rails",
    product_name: "Industrial_rails",
  },
  {
    product_id: "SSU6B",
    product_category: "crane_rails",
    product_name: "used_and_new_rails",
  },
  {
    product_id: "SSB1",
    product_category: "structural_steel-long_products",
    product_name: "mild_steel_beam(ISMB)",
    product_rows: "Size(in mm),length(in mtr),Grades",
    value1: "100x50x5 to 600x210x12",
    value2: "As per Requirement",
    value3: "E250,E275,E300,E350,E410,E450",
  },

  {
    product_id: "SFT2",
    product_category: "",
    product_name: "cut_plates/special_size_plates",
  },

  {
    product_id: "SFP5",
    product_category: "structural_steel-flat_products",
    product_name: "mild_steel_plate",
    product_rows: "standard length,standard width",
    value1: " 4 to 40 mm",
    value2: "900 to 3000 mm",
  },
  {
    product_id: "SFB3",
    product_category: "structural_steel-flat_products",
    product_name: "boiler_quality_plates",
    product_rows: "thickness(in mm),width(in mm)",
    value1: "3 to 200",
    value2: "1250 to 4000",
  },
  {
    product_id: "SFC1",
    product_category: "structural_steel-flat_products",
    product_name: "cold_rolled_sheet",
    product_rows: "thickness(in mm),width(in mm),Grades",
    value1: "0.14-3.2",
    value2: "Can be up to 1850mm, depending on the application.",
    value3: "IS 513,IRSM 41",
  },
  {
    product_id: "SFS6",
    product_category: "structural_steel-flat_products",
    product_name: "SAIL_hard_plates",
    product_rows: "width,thickness.length,grades",
    value1: "1250mm to 3000mm",
    value2: "6mm to 120mm",
    value3: "5m to 12m  ",
  },
  {
    product_id: "SFT2",
    product_category: "structural_steel-flat_products",
    product_name: "cut_plates/special_size_plates",
    product_rows:
      "Any Thickness/size with(or)without holes available with Laser/CNC cutting.",
    value1: undefined,
  },
  {
    product_id: "SFE9",
    product_name: "Chequered_plates",
    product_rows: "Thickness(in mm),Grade",
    value1: "3 to 10",
    value2: "IS 3502",
  },

  // scaffolding products
  //  { id: "SAA1", name: "Swivel Couplers" },
  //       { id: "SAT8", name: "Tie Rods" },
  //       {
  //         id: "SAC4",
  //         name: "All Types of Clamps",
  //       },
  //       { id: "SAW3", name: "Waller Plate" },
  //       { id: "SAP6", name: "Adjustable Props" },
  //       { id: "SAB2", name: "Base Jack & U Jack" },
  //       { id: "SAW7", name: "Wedge Clip Etc." },
  {
    product_id: "SAA1",
    product_category: "scaffolding_products",
    product_name: "swivel_couplers",
  },
  {
    product_id: "SAT8",
    product_category: "scaffolding_products",
    product_name: "tie_rods",
  },
  {
    product_id: "SAC4",
    product_category: "scaffolding_products",
    product_name: "shuttering_clamp",
  },
  {
    product_id: "SAW3",
    product_category: "scaffolding_products",
    product_name: "waller_plate",
  },
  {
    product_id: "SAP6",
    product_category: "scaffolding_products",
    product_name: "adjustable_props",
  },
  {
    product_id: "SAB2",
    product_category: "scaffolding_products",
    product_name: "base_jack_and_u_jack",
    sub_products: [
      { product_id: "SAB2B", product_name: "base_jack" },
      { product_id: "SAB2U", product_name: "u_jack" },
    ],
  },
  {
    product_id: "SAW7",
    product_category: "scaffolding_products",
    product_name: "wedge_clip_etc.",
  },

  //  other products
  {
    product_id: "OPA3",
    product_name: "aluminium_products",
    product_category: "other_products",
    sub_products: [
      { product_id: "OPE1", product_name: "aluminium_sections" },
      { product_id: "OPE2", product_name: "aluminium_sheet" },
    ],
  },
  {
    product_id: "OPC5",
    product_name: "copper_products",
    product_category: "other_products",
    sub_products: [
      { product_id: "OPC2", product_name: "copper_sheet" },
      { product_id: "OPC1", product_name: "copper_flat" },
    ],
  },
  {
    product_id: "OPS9",
    product_name: "stainless_steels_products",
    product_category: "other_products",
    sub_products: [
      { product_id: "OPS1", product_name: "stainless_steel_pipe" },
      { product_id: "OPS2", product_name: "stainless_steel_plate" },
    ],
  },
  {
    product_id: "OPM1",
    product_name: "metal_beam_crash_barrier",
    product_category: "other_products",
  },
  {
    product_id: "OPC2",
    product_name: "copper_sheet",
    product_category: "other_products",
    product_rows: "Grades,purity,conductivity",
    value1: "ISI 191,613,1897",
    value2: "99.9%",
    value3: ">98.5%",
  },
];

export {
  Home_Map_Data,
  Home_IndustriesWeServe_Data,
  Home_WhyChooseUs_Data,
  Certificates_Data,
  Brands_Data,
  WireProducts_Data,
  Products_Data,
};
